export const  CARDS_API_EVENTS = {
    API_SUCCESS_CARD_THEME_LIST_RETRIEVAL:'api_success_card_theme_list_retrieval',
    API_ERROR_CARD_THEME_LIST_RETRIEVAL:'api_error_card_theme_list_retrieval'
}